import { EDITOR } from 'constants/actionTypes';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import filestackImageUpload from 'misc/imageUpload';
import { autosaveInProgress, autosaveSuccess, autosaveFail } from './index';

const templateDetailsUpdate = changes => ({
  type: EDITOR.TEMPLATE.UPDATE,
  ...changes,
});

const templateStatusChange = status => ({
  type: EDITOR.TEMPLATE.TOGGLE_STATUS,
  status,
});

const templateImageChange = (image, imageType) => ({
  type: EDITOR.TEMPLATE.IMAGE_CHANGE,
  image,
  imageType,
});

export const templateToggleAddToLibrary = (visible, imageType) => ({
  type: EDITOR.TEMPLATE.TOGGLE_ADD_TO_LIBRARY,
  visible,
  imageType,
});

export const templateToggleImageLibrary = (visible, imageType) => ({
  type: EDITOR.TEMPLATE.TOGGLE_IMAGE_LIBRARY,
  visible,
  imageType,
});

export const templateToggleImageSuccess = success => ({
  type: EDITOR.TEMPLATE.TOGGLE_IMAGE_SUCCESS,
  success,
});

// @TODO id here is the section’s id, but should be the lesson’s
export const requestUpdate = (id, changes) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const { lesson_title_update } = getState().editor;

    dispatch(autosaveInProgress());
    request
      .put(lesson_title_update, { lesson: changes })
      .done(data => {
        dispatch(autosaveSuccess());
        dispatch(templateDetailsUpdate(changes));
      })
      .fail(error => {
        dispatch(autosaveFail());
        reject(error);
      });
  });

export const requestStatusChange = status => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const { lesson_title_update } = getState().editor;

    dispatch(autosaveInProgress());

    request
      .put(lesson_title_update, { lesson: { active_template: status } })
      .done(data => {
        dispatch(autosaveSuccess());
        dispatch(templateStatusChange(status));
        request.getScript(routes.NOTIFICATIONS_LATEST);
        resolve();
      })
      .fail(error => {
        dispatch(autosaveFail());
        reject(error);
      });
  });

export const uploadToFilestack = imageParams => dispatch =>
  new Promise((resolve, reject) => {
    filestackImageUpload(imageParams)
      .then(image => {
        dispatch(templateToggleImageSuccess(true));
        dispatch(templateImageChange(image, imageParams.image_type));
        dispatch(templateToggleAddToLibrary(true, imageParams.image_type));
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });

export const removeImage = (image, imageParams) => dispatch =>
  new Promise((resolve, reject) => {
    request
      .delete(routes.IMAGE(image.id), imageParams)
      .then(() => {
        dispatch(templateToggleImageSuccess(true));
        dispatch(templateImageChange(null, imageParams.image.image_type));
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });

export const selectLibraryImage = imageParams => dispatch =>
  new Promise((resolve, reject) => {
    request
      .post(routes.ASSOCIATED_IMAGES, imageParams)
      .then(image => {
        dispatch(templateToggleImageSuccess(true));
        dispatch(templateImageChange(image, imageParams.image_type));
        dispatch(templateToggleImageLibrary(false, imageParams.image_type));
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
